'use strict';

var StandardTileView = Marionette.LayoutView.extend({
    getTemplate: function () {
        return this.template ? this.template : this.options.template;
    },

    serializeData: function () {
        return this.options;
    },

    onRender: function () {
        $('.js-tile-body').slimScroll({
            height: '100%',
            railVisible: true,
        });
    },

    onShow: function () {
        $('.slimScrollBar').hide();
    },

    getHeaderConfiguration: function () {
        return this.options.header;
    },

    getFooterConfiguration: function () {
        return this.options.footer;
    },

    updateFooter: function () {
        this.triggerMethod('update:footer', this.getFooterConfiguration());
        $('.tooltip').tooltip('hide');
        $('button').tooltip({
            html: true,
            container: 'body',
            trigger: 'hover',
        });
    },

    updateHeader: function () {
        this.triggerMethod('update:header', this.getHeaderConfiguration());
    },
});

module.exports = StandardTileView;
